<script setup lang="ts">
import {computed, defineProps} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 10,
  },
  color: {
    type: String,
    default: '#000',
  },
})

const width = computed(() => {
  return props.height * 0.7
})
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 7 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
       fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd">
    <g transform="matrix(1,0,0,1,-8.98771,-6.98771)">
        <g id="Right" transform="matrix(-1,0,0,1,23.9855,0)">
            <path d="M14.707,12.707L10.707,16.707C10.521,16.887 10.271,16.988 10.012,16.988C9.464,16.988 9.012,16.536 9.012,15.988C9.012,15.729 9.113,15.479 9.293,15.293L12.586,12L9.293,8.707C9.098,8.519 8.988,8.259 8.988,7.988C8.988,7.439 9.439,6.988 9.988,6.988C10.259,6.988 10.519,7.098 10.707,7.293L14.707,11.293C15.095,11.681 15.095,12.319 14.707,12.707Z" :fill="color"
                  fill-rule="nonzero"/>
        </g>
    </g>
</svg>

</template>

<style scoped lang="less">

</style>
